/**
 * @author Jeanne Clavel
 * @version 1.0.0
 *
 * @param target HTMLElement - La cible HTML
 * @export function trapFocus - Exemple : trapFocus(target)
 * bloque le focus dans target, et focus automatiquement le premier element focusable de target
 *
 */
export function trapFocus(target) {
  const tabbable = target.querySelectorAll(
    'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled]), details:not([disabled]), summary:not(:disabled)'
  );

  if (tabbable.length === 0) return;

  const firstTabbable = tabbable[0];
  const lastTabbable = tabbable[tabbable.length - 1];

  firstTabbable.focus();

  lastTabbable.addEventListener("keydown", e => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();
      firstTabbable.focus();
    }
  });

  firstTabbable.addEventListener("keydown", e => {
    if (e.key === "Tab" && e.shiftKey) {
      e.preventDefault();
      lastTabbable.focus();
    }
  });
}
